<div class="hw-grid-switch" title="{{ cellValue }}">
    <fn-switch [(ngModel)]="cellValue" [name]="'type'" [isDisabled]="isDisable" (ngModelChange)="changeAction()"></fn-switch>
</div>

<!-- <div class="table-content" *ngIf="!isEditMode" title="{{ cellValue }}">
    <fn-switch [(ngModel)]="cellValue" [name]="'type'"> </fn-switch> ngModelChange
</div> -->
